import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./EngagementUnitList'),
  loading: () => <Loading withContentWrapper />,
});
